module.exports = __webpack_public_path__ + "img/s2P16.df10cd20.png";